export const selectMessages = {
  placeholder: 'Seçin…',
  noOptionsMessage: ({inputValue}: {inputValue: string}) => inputValue
    ? 'Aramanızla eşleşen sonuç bulunamadı.'
    : 'Henüz seçenek bulunmuyor.',
  loadingMessage: () => 'Seçenekler yükleniyor…',
}
